import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { getCrmDomainAssignmentEventsForCompanyVidRpc, getCrmDomainAssignmentEventsForContactVidRpc } from '../generated/BizOpsCrmCardsService-v3/operations';
import { createRpcClientV2 } from 'rpc-client-utils';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
function getContactAssignmentHistory({
  objectId,
  timestamp
}) {
  return rpcClient.call(getCrmDomainAssignmentEventsForContactVidRpc, {
    pathParameters: {
      contactVid: objectId
    },
    queryParameters: {
      limit: 20,
      timestamp
    }
  });
}
function getCompanyAssignmentHistory({
  objectId,
  timestamp
}) {
  return rpcClient.call(getCrmDomainAssignmentEventsForCompanyVidRpc, {
    pathParameters: {
      companyVid: objectId
    },
    queryParameters: {
      limit: 20,
      timestamp
    }
  });
}
function getAssignmentHistory({
  objectId,
  objectType,
  timestamp
}) {
  return objectType === CONTACT ? getContactAssignmentHistory({
    objectId,
    timestamp
  }) : getCompanyAssignmentHistory({
    objectId,
    timestamp
  });
}
const AssignmentHistoryFieldName = 'assignmentHistory';
export const GET_ASSIGNMENT_HISTORY = registerQuery({
  args: ['objectId', 'objectType', 'timestamp'],
  fetcher: getAssignmentHistory,
  fieldName: AssignmentHistoryFieldName
});
export function useAssignmentHistoryQuery(options) {
  return useQuery(GET_ASSIGNMENT_HISTORY, options);
}